var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 4L12.6654 4L12.0817 12.7554C12.035 13.4558 11.4532 14 10.7513 14L5.2461 14C4.54415 14 3.96241 13.4558 3.91572 12.7554L3.33203 4Z",
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4V2L10 2V4",
    stroke: "#7F7F84",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L14 4",
    stroke: "#7F7F84",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 6.66675L6.66797 11.3334",
    stroke: "#7F7F84",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 6.66675V11.3334",
    stroke: "#7F7F84",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashLogo);
export default __webpack_public_path__ + "static/media/trash_logo.ca5ba3252d358ac6c438280819289ed9.svg";
export { ForwardRef as ReactComponent };